export const equalShallowCheck = (x, y) => {
    if (!x || !y) return false;
    const xKeys = Object.keys(x);
    const yKeys = Object.keys(y);
    if (xKeys.length !== yKeys.length) return false;
    for (const q of xKeys) {
        if (x[q] !== y[q]) return false;
    }
    return true;
};